// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"df8aafd4","240":"bdc2575e","241":"76bd5cd4","300":"bfafda9b","395":"53efaf7a","570":"866fa1be","617":"aa341ff4","649":"06314d99","754":"b16ac050","960":"3be3f041"}[chunkId] + ".chunk.js";
};